import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
} from './style';

import IntroCloud from '../IntroCloud';
import IntroSlideshow from '../IntroSlideshow';
import IntroCloudFilter from '../IntroCloudFilter';

import AppState from '../../states/AppState';
import IntroCloudState from '../../states/IntroCloudState';

class Intro extends Component {
  render() {

    return (
      <Wrapper
        className={AppState.scrollTop > AppState.windowHeight ? 'inactive' : 'active'}
        style={{
          height: IntroCloudState.containerHeight,
          width: IntroCloudState.containerWidth,
        }}
      >
        <IntroCloudFilter />
        <IntroCloud />
        <IntroSlideshow />
      </Wrapper>
    );
  }
}

export default observer(Intro);



// WEBPACK FOOTER //
// ./src/components/Intro/index.js